export enum ModuleType {
    Private = 'private',
    ELearning = 'e_learning',
    Basic = 'basic',
    Program = 'program',
    Course = 'course',
}
